const divCardsTimeLine = {
  action: 'Ação',
  item: 'Item Relacionado',
  service: 'Serviço',
  accountable: 'Responsáveis'
};

export default divCardsTimeLine;
